import { Link } from "react-router-dom";

export default function Footer() {
  /* ───────────────────────── Desktop (≥ md) ───────────────────────── */
  const DesktopFooter = () => (
    <footer className="hidden md:block bg-black text-white p-28 mx-32 mb-8 rounded-[25px]">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between gap-10">
        {/* Logo + réseaux */}
        <div className="flex flex-col gap-5">
          <img
            src="/images/logo/Same_Blanc.png"
            alt="Logo SAME"
            className="w-26 h-14"
            loading="lazy"
          />
          <div className="flex gap-4 text-xl">
            {/* TikTok */}
            <a
              href="https://www.tiktok.com/@same.corp"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
              title="TikTok"
              className="hover:underline"
            >
              {/* (svg tiktok) */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                className="w-6 h-6 fill-current"
              >
                <path d="M448 209.3v-70.1c-22.8 0-44.8-7.5-62.5-21.6S355.2 84.4 350.4 62.7c-2.1-9.5-3.2-19.3-3.3-29.2h-70.5v281.9c0 23.7-8.4 44.6-25.1 62.5C235 391.9 214.9 400.9 191.5 400.9c-23.9 0-44.2-8.5-60.8-25.4s-25-37.8-25-61.9c0-24.1 8.4-44.9 25.1-62.5 16.7-17.6 37-26.4 60.8-26.4 5.4 0 10.9.6 16.4 1.9V193c-5.2-.7-10.6-1.1-16.1-1.1-35.4 0-65.5 11.5-90.3 34.6S41.8 278.7 41.8 313.4c0 34.9 12.4 64.2 37.3 88 24.9 23.8 56.2 35.6 93.8 35.6 35.3 0 65.4-12.1 90.3-36.4 24.9-24.3 37.3-54.7 37.3-91.4V185.7c19.1 13.8 41.5 22.1 66.3 24.9z" />
              </svg>
            </a>
            {/* Instagram (plein) */}
            <a
              href="https://www.instagram.com/same.corp/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
              aria-label="Instagram"
              title="Instagram"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
                className="w-6 h-6"
              >
                <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5A4.25 4.25 0 0 0 20.5 16.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5Zm8.75 2.25a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5ZM12 7.25a4.75 4.75 0 1 1 0 9.5a4.75 4.75 0 0 1 0-9.5Zm0 1.5a3.25 3.25 0 1 0 0 6.5a3.25 3.25 0 0 0 0-6.5Z" />
              </svg>
            </a>
          </div>
        </div>

        {/* Colonnes de liens */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 text-sm ">
          <div className="flex flex-col gap-2">
            <span className="font-bold uppercase">Explorer</span>
            <Link to="/" className="hover:underline">
              Accueil
            </Link>
            <Link to="/uniquepiece" className="hover:underline">
              Pièces uniques
            </Link>
          </div>
          <div className="flex flex-col gap-2">
            <span className="font-bold uppercase">Politique</span>
            <Link to="/conditions-générales" className="hover:underline">
              Conditions générales
            </Link>
          </div>
          <div className="flex flex-col gap-2">
            <span className="font-bold uppercase">Soutien</span>
            <Link to="/a-propos" className="hover:underline">
              À propos
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );

  /* ───────────────────────── Mobile (< md) ───────────────────────── */
  const MobileFooter = () => (
    <footer className="block md:hidden bg-black text-white px-6 py-12 mx-4 mb-8 rounded-[25px]">
      <div className="flex flex-col items-center gap-10">
        {/* Logo */}
        <img
          src="/images/logo/Same_Blanc.png"
          alt="Logo SAME"
          className="w-24 h-10"
          loading="lazy"
        />

        {/* Réseaux */}
        <div className="flex gap-6 text-xl">
          <a
            href="https://www.tiktok.com/@same.corp"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
            title="TikTok"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              className="w-6 h-6 fill-current"
            >
              <path d="M448 209.3v-70.1c-22.8 0-44.8-7.5-62.5-21.6S355.2 84.4 350.4 62.7c-2.1-9.5-3.2-19.3-3.3-29.2h-70.5v281.9c0 23.7-8.4 44.6-25.1 62.5C235 391.9 214.9 400.9 191.5 400.9c-23.9 0-44.2-8.5-60.8-25.4s-25-37.8-25-61.9c0-24.1 8.4-44.9 25.1-62.5 16.7-17.6 37-26.4 60.8-26.4 5.4 0 10.9.6 16.4 1.9V193c-5.2-.7-10.6-1.1-16.1-1.1-35.4 0-65.5 11.5-90.3 34.6S41.8 278.7 41.8 313.4c0 34.9 12.4 64.2 37.3 88 24.9 23.8 56.2 35.6 93.8 35.6 35.3 0 65.4-12.1 90.3-36.4 24.9-24.3 37.3-54.7 37.3-91.4V185.7c19.1 13.8 41.5 22.1 66.3 24.9z" />
            </svg>
          </a>
          <a
            href="https://www.instagram.com/same.corp/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
            aria-label="Instagram"
            title="Instagram"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
              className="w-6 h-6"
            >
              <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5A4.25 4.25 0 0 0 20.5 16.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5Zm8.75 2.25a.75.75 0 1 1 0 1.5a.75.75 0 0 1 0-1.5ZM12 7.25a4.75 4.75 0 1 1 0 9.5a4.75 4.75 0 0 1 0-9.5Zm0 1.5a3.25 3.25 0 1 0 0 6.5a3.25 3.25 0 0 0 0-6.5Z" />
            </svg>
          </a>
        </div>

        {/* Liens */}
        <div className="grid grid-cols-1 gap-6 text-center text-sm">
          <div className="flex flex-col gap-2">
            <span className="font-bold uppercase">Explorer</span>
            <Link to="/">Accueil</Link>
          </div>
          <div className="flex flex-col gap-2">
            <span className="font-bold uppercase">Politique</span>
            <Link to="/conditions-générales">Conditions générales</Link>
          </div>
          <div className="flex flex-col gap-2">
            <span className="font-bold uppercase">Soutien</span>
            <Link to="/a-propos">À propos</Link>
          </div>
        </div>
      </div>
    </footer>
  );

  return (
    <>
      <DesktopFooter />
      <MobileFooter />
    </>
  );
}
